var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCopyDefaultFilled = function SvgCopyDefaultFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#2563EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.085 14.085c.196-.03.371-.069.536-.122a4.167 4.167 0 0 0 2.675-2.675c.204-.628.204-1.404.204-2.955 0-1.55 0-2.326-.204-2.954a4.167 4.167 0 0 0-2.675-2.675c-.628-.204-1.403-.204-2.954-.204-1.551 0-2.327 0-2.955.204a4.167 4.167 0 0 0-2.675 2.675c-.053.165-.093.34-.122.536m8.17 8.17c.082-.552.082-1.274.082-2.418 0-1.551 0-2.327-.204-2.955a4.166 4.166 0 0 0-2.675-2.675c-.628-.204-1.404-.204-2.955-.204-1.144 0-1.866 0-2.418.082m8.17 8.17c-.03.196-.069.371-.122.536a4.167 4.167 0 0 1-2.675 2.675c-.628.204-1.404.204-2.955.204-1.55 0-2.326 0-2.954-.204a4.167 4.167 0 0 1-2.675-2.675c-.204-.628-.204-1.403-.204-2.954 0-1.551 0-2.327.204-2.955a4.167 4.167 0 0 1 2.675-2.675c.165-.053.34-.093.536-.122"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2563EB",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "M5 12.664 7.341 15l.187-.327a13.338 13.338 0 0 1 4.06-4.392L12 10"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCopyDefaultFilled);
export default ForwardRef;